export enum SSOInternalErrorCodesEnum {
    InvalidToken = 1,
    UserNotFound = 2,
    InvalidUser = 3,
    AccountLocked = 4,
    InternalServerError = 5,
}
